import { render, staticRenderFns } from "./electricityReport.vue?vue&type=template&id=187270c9&scoped=true"
import script from "./electricityReport.vue?vue&type=script&lang=js"
export * from "./electricityReport.vue?vue&type=script&lang=js"
import style0 from "./electricityReport.vue?vue&type=style&index=0&id=187270c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187270c9",
  null
  
)

export default component.exports